(function (window, $) {
	window.app.register('itemAmount', function ($el, options) {
		$el.find('.order-amount-minus-button').on('click', function (e){
			$input = $(this).closest('.order-button-amount').find('[data-order-amount-input-js]');
			$value = $input.val() * 1;
			if ($value > $input.attr('min')) {
				$input.val($value - 1);
			}
			$(this).closest('form').find('[data-app-item-amount-control-submit]').netteAjax(e);
		});

		$el.find('.order-amount-plus-button').on('click', function (e) {
			$input = $(this).closest('.order-button-amount').find('[data-order-amount-input-js]');
			$value = $input.val() * 1;

			if ($value < $input.attr('max')) {
				$input.val($value + 1);
			}
			else {
				alert("Maximální počet kusů tohoto produktu v objednávce je " + $input.attr('max'));
			}
			$(this).closest('form').find('[data-app-item-amount-control-submit]').netteAjax(e);
		});

		$el.find('[data-order-amount-input-js]').on('change', function (e) {
			$value = $(this).val() * 1;
			if (! Number.isInteger($value) || $value < $(this).attr('min') || $value > $(this).attr('max')) {
				if ($value > $(this).attr('max')) {
					alert("Maximální počet kusů tohoto produktu v objednávce je " + $input.attr('max'));
				}

				$(this).val($(this).attr('data-value'));
				return;
			}
			$(this).closest('form').find('[data-app-item-amount-control-submit]').netteAjax(e);
		});
	}, {
		// Vo foodAndProductControl pouzivame data-ajax-append
		availableCommands: [
			'continueOnAlreadyInitializedComponent'
		],
	});
}(window, jQuery));